// extracted by mini-css-extract-plugin
export default {"card":"O6-z"};